import { DotFillIcon } from '@primer/octicons-react';
import { LTProgressBar, LTText } from '@lambdatestincprivate/lt-components';
import { formatDurationMs } from '../format';
import styles from './summary.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PASSED = '#176F2C';
var FAILED = '#CF222E';
var OTHERS = '#666666';

/** Pass rate, duration, legend and the segmented progress bar — the left
 * half of the summary strip. Others = broken + skipped (the two are still
 * reported separately for screen readers and in the row icons). */
export function RunSummaryCard(_ref) {
  var run = _ref.run;
  var totals = run.totals;
  var others = totals.broken + totals.skipped;
  var pct = function pct(n) {
    return totals.tests > 0 ? n / totals.tests * 100 : 0;
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.card,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.cardInner,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.metric,
        children: [/*#__PURE__*/_jsx("span", {
          className: "ev-t-num20",
          children: run.passRatePct === null ? '—' : "".concat(run.passRatePct, "%")
        }), /*#__PURE__*/_jsx(LTText, {
          text: "Pass Rate",
          color: "#636C76",
          variant: LTText.TextVariant.SUBHEADER_BOLD
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.metric,
        children: [/*#__PURE__*/_jsx("span", {
          className: "ev-t-num20",
          children: formatDurationMs(run.durationMs)
        }), /*#__PURE__*/_jsx(LTText, {
          text: "Duration",
          color: "#636C76",
          variant: LTText.TextVariant.SUBHEADER_BOLD
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.progressSection,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.legend,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.legendItem,
            children: [/*#__PURE__*/_jsx(DotFillIcon, {
              fill: PASSED
            }), /*#__PURE__*/_jsxs(LTText, {
              variant: LTText.TextVariant.SUBHEADER_REGULAR,
              color: "var(--lt-text-primary)",
              children: [/*#__PURE__*/_jsx(LTText, {
                as: "span",
                variant: LTText.TextVariant.SUBHEADER_BOLD,
                color: "var(--lt-text-primary)",
                children: String(totals.passed)
              }), ' ', "Passed"]
            })]
          }), /*#__PURE__*/_jsxs("span", {
            className: styles.legendItem,
            children: [/*#__PURE__*/_jsx(DotFillIcon, {
              fill: FAILED
            }), /*#__PURE__*/_jsxs(LTText, {
              variant: LTText.TextVariant.SUBHEADER_REGULAR,
              color: "var(--lt-text-primary)",
              children: [/*#__PURE__*/_jsx(LTText, {
                as: "span",
                variant: LTText.TextVariant.SUBHEADER_BOLD,
                color: "var(--lt-text-primary)",
                children: String(totals.failed)
              }), ' ', "Failed"]
            })]
          }), /*#__PURE__*/_jsxs("span", {
            className: styles.legendItem,
            title: "".concat(totals.broken, " broken, ").concat(totals.skipped, " skipped"),
            children: [/*#__PURE__*/_jsx(DotFillIcon, {
              fill: OTHERS
            }), /*#__PURE__*/_jsxs(LTText, {
              variant: LTText.TextVariant.SUBHEADER_REGULAR,
              color: "var(--lt-text-primary)",
              children: [/*#__PURE__*/_jsx(LTText, {
                as: "span",
                variant: LTText.TextVariant.SUBHEADER_BOLD,
                color: "var(--lt-text-primary)",
                children: String(others)
              }), ' ', "Others", /*#__PURE__*/_jsx("span", {
                className: "ev-sr-only",
                children: " (".concat(totals.broken, " broken, ").concat(totals.skipped, " skipped)")
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(LTProgressBar, {
          ariaLabel: "".concat(totals.passed, " passed, ").concat(totals.failed, " failed, ").concat(others, " others of ").concat(totals.tests, " tests"),
          segments: [{
            id: 'passed',
            progress: pct(totals.passed),
            style: {
              backgroundColor: PASSED
            }
          }, {
            id: 'failed',
            progress: pct(totals.failed),
            style: {
              backgroundColor: FAILED
            }
          }, {
            id: 'others',
            progress: pct(others),
            style: {
              backgroundColor: OTHERS
            }
          }]
        })]
      })]
    })
  });
}